import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import { smoothScroll } from '@/helpers/utils.js'

Vue.use(VueRouter)

// https://router.vuejs.org/guide/advanced/scroll-behavior.html
const scrollBehavior = function (to) {
  // Scroll to hash if present, else reset position
  if (to.hash) {
    smoothScroll(to.hash, 1000, 100);
  } else {
    return { x: 0, y: 0 }
  }
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    redirect: { name: 'Home' }
  },
  {
    path: '/projects/:id',
    name: 'ProjectDetail',
    redirect: { name: 'Home' }
    //component: () => import('../views/ProjectDetail.vue')
  },
  {
    path: '/sayhello/',
    name: 'SayHello',
    redirect: { name: 'Home' }
    //component: () => import('../views/SayHello.vue')
  },
  {
    path: '/admin/',
    name: 'Admin',
    component: () => import('../views/Admin.vue'),
    meta: {
        requiresAuth: true,
    }
  },
  {
    path: '/login/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      guest: true
    }
  },
  {
    path: "*",
    component: () => import("../views/NotFound.vue")
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes
});

export default router
